module.exports = __webpack_public_path__ + "img/1024_dialog_footer.61aa7326.png";